<div class="modal-container">
  <button class="btn close-modal" (click)="activeModal.dismiss()">
    <i class="fas fa-times"></i>
  </button>
  <div class="d-flex align-items-center buttons">
    <h4 class="title">
      @if (mode != 'header') {
        <input
          type="text"
          placeholder="Nombre de la cláusula..."
          [formControl]="nameField">
      } @else {
        Encabezado
      }
    </h4>
    @if (mode != 'header' && mode != 'createClause' && mode != 'editClause') {
      <button
        class="btn save"
        (click)="openSubjectSelector()">
        Guardar como cláusula
      </button>
    }
    @if (mode != 'header' && mode != 'createClause' && mode != 'editClause') {
      <button
        class="btn save"
        (click)="openCustomfieldSelector()">
        {{'{...}'}}
      </button>
    }
  </div>
  @if (displayErrors) {
    @for (error of errors; track error) {
      <ngb-alert type="danger" [dismissible]="false">{{error}}</ngb-alert>
    }
    @if (nameField.errors?.required) {
      <ngb-alert type="danger" [dismissible]="false">Debes ingresar un nombre de cláusula</ngb-alert>
    }
    @if (nameField.errors?.maxlength) {
      <ngb-alert type="danger" [dismissible]="false">El nombre debe tener 50 caracteres como máximo</ngb-alert>
    }
  }
  <div class="d-flex align-items-center personalize-summernote">
    <div class="flex-fill">
      <quill-editor [formControl]="contentField" [modules]="summernoteConfig"></quill-editor>
    </div>
    @if (_requirementtypeid && (mode == 'create' || mode == 'edit')) {
      <button
        class="ml-3 btn fields-button"
        placement="left"
        [ngbPopover]="customfieldsPopover">
        {{'{...}'}}
      </button>
      <ng-template #customfieldsPopover>
        <table class="table table-hover">
          <tbody>
            @for (field of customFields; track field) {
              <tr class="clickable" (click)="copyFieldToClipboard(field)">
                <td>{{field.name}}</td>
                <td><i class="far fa-copy"></i></td>
              </tr>
            }
          </tbody>
        </table>
      </ng-template>
    }
  </div>
  @if (showMessage) {
    <ngb-alert class="mt-4" type="success" [dismissible]="false">Campo copiado al portapapeles</ngb-alert>
  }
  <div class="d-flex justify-content-center">
    @switch (mode) {
      @case (['createClause', 'editClause'].includes(mode) ? mode : !mode) {
        <button
          class="btn round-button"
          (click)="openSubjectSelector()">
          Guardar
        </button>
      }
      @case ('header') {
        <button
          class="btn round-button"
          (click)="returnHeader()">
          Guardar
        </button>
      }
      @default {
        <button
          class="btn round-button"
          (click)="returnSection()">
          Guardar
        </button>
      }
    }
  </div>
</div>